import { addCanvasImage } from '~core/image';

export const replaceImageUrlsWithImage = async () => {
  const textObjects = window.canvas
    .getObjects()
    .filter((obj) => obj.type === 'textbox' && obj.text.startsWith('imghttps'));

  for (const textObject of textObjects) {
    const url = textObject.get('text').substring(3);
    const options = {
      top: textObject.top,
      left: textObject.left,
    };
    const image = await addCanvasImage(url, options);
    image.scaleToHeight(textObject.get('height') * textObject.get('scaleY'));
    window.canvas.remove(textObject);
    window.canvas.renderAll();
  }
};
